/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */
export var ValidationDocumentType;

(function (ValidationDocumentType) {
  ValidationDocumentType["UNSPECIFIED"] = "unspecified";
  ValidationDocumentType["SCHEDULE"] = "schedule";
  ValidationDocumentType["CERTIFICATE"] = "certificate";
})(ValidationDocumentType || (ValidationDocumentType = {}));